export const MAX_MODERATOR_NAME_LENGTH = 20;

export function limitModeratorName(value: string) {
  return value.slice(0, MAX_MODERATOR_NAME_LENGTH);
}

export function moderatorNameError(value: string, language: "ru" | "en") {
  const name = value.trim();
  if (!name) {
    return language === "en" ? "Enter a moderator name." : "Введите имя модератора.";
  }
  if (name.length > MAX_MODERATOR_NAME_LENGTH) {
    return language === "en" ? "Name must be 20 characters or fewer." : "Имя должно быть не длиннее 20 символов.";
  }
  return "";
}
